import { oz } from '@weft/utils';

export const REPORT_JOB_INVOCATION_TYPES = Object.freeze({
  Scheduled: 'Scheduled',
  Manual: 'Manual',
});

export const ReportJobInvocationTypesSchema = oz.nativeEnum(REPORT_JOB_INVOCATION_TYPES);

export type ReportJobInvocationTypes = oz.TypeOf<typeof ReportJobInvocationTypesSchema>;